import { render, staticRenderFns } from "./assessmentList.vue?vue&type=template&id=20b7ea76&scoped=true"
import script from "./assessmentList.vue?vue&type=script&lang=js"
export * from "./assessmentList.vue?vue&type=script&lang=js"
import style0 from "./assessmentList.vue?vue&type=style&index=0&id=20b7ea76&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b7ea76",
  null
  
)

export default component.exports